import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { EventService } from '../../services/event.service';
import { VideoService } from '../../services/video.service';
import { StoreSelectorService } from '../../services/storeselector.service';
import { StoreSelection } from '../../models/store';
import { Observable, Subscription } from 'rxjs';
import { Event } from '../../models/event';
import { VideoListItem } from '../../models/videoListItem';
import { VideoBundle } from '../../models/videoBundle';
import { isNullOrUndefined } from 'util';
import { Video } from '../../models/video';
import { AuthService } from '../../services/auth.service';

const WARNING_NO_VIDEO: string = "No video was recorded";

@Component({
  selector: 'app-security-event',
  templateUrl: './security-event.component.html',
  styleUrls: ['./security-event.component.scss']
})
export class SecurityEventComponent implements OnInit, OnDestroy {

  eventGuid: string;
  event: Event;
  
  eventInit: boolean = false; // show progress spinner if false
  showLoading: boolean = true; // show progress spinner for loading next video

  showNoVideosWarning: boolean = false;
  videoError: boolean = false;
  videoErrorMessage: string = "";

  private selectedStoreChangesSubscription: Subscription;

  videoBundles: VideoBundle[] = [];

  warningMessage = WARNING_NO_VIDEO;

  constructor(
    private _authService: AuthService,
    private router: Router,
    private _eventService: EventService, 
    private _videoService: VideoService,
    private _storeSelectorService: StoreSelectorService,
    private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.eventGuid = params['id']; // Get eventGuid stored in 'id' from route in url

      let initSelectedStore: StoreSelection = this._storeSelectorService.getSelectedStore();
      this.selectedStoreChangesSubscription = this._storeSelectorService.storeChanges.subscribe(() => {
        this.onStoreChange();
      });

      
  
      // Get event by eventGuid
      this._eventService.getEvent(this.eventGuid).then((eventRequest: Observable<Event>) => {
        eventRequest.subscribe((event: Event) => {
          this.event = event;
          this.eventInit = true;
          this.getVideos(this.event);
        });
      });
    });
  }

  ngOnDestroy() {
	  this.selectedStoreChangesSubscription.unsubscribe();
  }

  private onStoreChange() {
    this.router.navigate(["/securityevents"]);
  }

  refresh() {
    this.getVideos(this.event);
  }

  getVideos(event: Event) {
    this.videoError = false;
    this.videoErrorMessage = "";
    this.showNoVideosWarning = false;

    if(event.videoCount == 0) {
      // Display message that there are no videos
      this.showNoVideosWarning = true;
    } else {
      this.showLoading = true;
    }

    // Get list of Videos
    this._videoService.getVideoList(event.eventGuid).then((videoListRequest: Observable<VideoListItem[]>) => {
      videoListRequest.subscribe((videos: VideoListItem[]) => {

        // Handle VideoList
        this.videoBundles = [];

        if(isNullOrUndefined(videos)) {
          this.showLoading = false;
          this.showNoVideosWarning = true;
          return;
        }

        this.showLoading = true;
        this.showNoVideosWarning = false;

        let videosLoaded = 0;

        // Get individual Videos from List of Video
        // TO:DO make async, this is synchronous currently
        videos.forEach((videoListItem: VideoListItem) => {
          this._videoService.getVideo(videoListItem.videoGuid).then((videoRequest: Observable<Video>) => {
            videoRequest.subscribe((video: Video) => {
              videosLoaded += 1;
              //console.log("video loaded: " + videosLoaded + "/" + event.videoCount);
              if(videosLoaded >= event.videoCount) {
                this.showLoading = false;
              }

              // Handle Video
              let videoBundle: VideoBundle = new VideoBundle();
              videoBundle.videoListItem = videoListItem;
              videoBundle.video = video;

              this.videoBundles.push(videoBundle);
            })
          })
        })
      },
      err => {
        console.log("security-event: getVideoList error", err);
        this.videoError = true;
        this.videoErrorMessage = err;
        this.showLoading = false;
        this.showNoVideosWarning = false;
      },
      () => {
        // On completion
      })
    }, err => {
      console.log("security-event: getVideoList error 2", err);
      this.videoError = true;
      this.videoErrorMessage = err;
      this.showLoading = false;
      this.showNoVideosWarning = false;
    })
  }

  onBackClick(): void {
    this.router.navigate(["/securityevents"]);
  }

  logout(): void {
    this._authService.Logoff();
  }
}
